import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Badge, ActionButton } from "./CommonUI";
import SEO from "../../components/SEO";

const BLOG_POSTS = [
  {
    title: "The Best Job Search Websites in 2026 (And Which One You Actually Need)",
    description: "LinkedIn, Indeed, Glassdoor, ZipRecruiter, Wellfound, Dice, FlexJobs, Handshake — an honest breakdown of what each one is actually good for, what it costs, and which combination fits your search.",
    slug: "best-job-search-websites-2026",
    date: "September 2, 2026",
    image: "https://answerly.space/images/blog/homepage-ats-score-card.png",
    category: "Job Search"
  },
  {
    title: "Auto Apply Jobs: How These Tools Actually Work (And What to Watch For)",
    description: "Auto apply tools range from helpful autofill to fully automated mass-submission bots. The real difference, why recruiters and LinkedIn are cracking down on the latter, and what to actually look for.",
    slug: "auto-apply-jobs-explained",
    date: "September 2, 2026",
    image: "https://answerly.space/images/blog/extension-panel-live.png",
    category: "Job Search"
  },
  {
    title: "Answerly vs Simplify: Which One Should You Actually Install?",
    description: "Simplify and Answerly both autofill job applications, but they're built around different tradeoffs. An honest breakdown of coverage, pricing, and what each one actually does.",
    slug: "answerly-vs-simplify",
    date: "August 20, 2026",
    image: "https://answerly.space/images/blog/extension-panel-live.png",
    category: "Comparisons"
  },
  {
    title: "Answerly's Auto Apply: How It Actually Works",
    description: "Auto Apply queues job applications and fills them in the background, but it never submits without you. Here's exactly how it works, and what it doesn't do.",
    slug: "answerly-auto-apply-explained",
    date: "August 19, 2026",
    image: "https://answerly.space/images/blog/extension-panel-live.png",
    category: "Product"
  },
  {
    title: "How Answerly's Autofill Actually Works",
    description: "Answerly autofills job applications from your resume on a verified set of ATS platforms, and never submits without you. Here's exactly how the mapping works.",
    slug: "how-answerly-autofill-works",
    date: "August 19, 2026",
    image: "https://answerly.space/images/blog/extension-panel-live.png",
    category: "Product"
  },
  {
    title: "Answerly vs Teal: Which One Should You Actually Install?",
    description: "Teal and Answerly are both Chrome extensions for job seekers, but they solve different problems. An honest breakdown of what each one does, what it costs, and which fits your search.",
    slug: "answerly-vs-teal",
    date: "August 19, 2026",
    image: "https://answerly.space/images/blog/homepage-ats-score-card.png",
    category: "Comparisons"
  },
  {
    title: "Why Your Resume Fails ATS Scans (And How to Fix It in 2026)",
    description: "75% of resumes are rejected by ATS bots. Learn the 5 most common formatting mistakes and how to fix them.",
    slug: "why-resume-fails-ats",
    date: "March 20, 2026",
    image: "https://answerly.space/images/blog/ats-engine-status-card.png",
    category: "ATS Strategy"
  },
  {
    title: "The Ultimate AI Resume Writing Guide",
    description: "Is AI resume writing worth it? Learn how to use Claude and Gemini to write a resume that actually gets interviews.",
    slug: "ai-resume-writing-guide",
    date: "March 18, 2026",
    image: "https://answerly.space/images/blog/homepage-ats-score-card.png",
    category: "AI Tools"
  },
  {
    title: "Best Job Trackers for 2026: Organize Your Search",
    description: "Stop using spreadsheets. Discover the best tools to track your applications, interviews, and follow-ups in 2026.",
    slug: "best-job-tracker-2026",
    date: "March 15, 2026",
    image: "https://answerly.space/images/blog/topic-job-tracker.png",
    category: "Organization"
  },
  {
    title: "Achievements vs. Responsibilities: Which One Wins?",
    description: "Most resumes are just job descriptions. Learn how to transform your boring duties into high-impact achievements.",
    slug: "achievements-vs-responsibilities-resume",
    date: "March 12, 2026",
    image: "https://answerly.space/images/blog/topic-achievements-vs-responsibilities.png",
    category: "Resume Writing"
  },
  {
    title: "How to Quantify Resume Bullets Without Hard Data",
    description: "Don't have million-dollar results? You can still use numbers. Here's how to quantify any job role effectively.",
    slug: "quantify-resume-bullets-no-data",
    date: "March 10, 2026",
    image: "https://answerly.space/images/blog/topic-quantify-bullets.png",
    category: "Resume Writing"
  },
  {
    title: "Workday ATS Optimization Guide",
    description: "Workday is the most common ATS. Learn the specific formatting tricks needed to pass the Workday parser.",
    slug: "workday-ats-optimization-guide",
    date: "March 8, 2026",
    image: "https://answerly.space/images/blog/topic-workday-ats.png",
    category: "ATS Strategy"
  },
  {
    title: "Explaining a Gap Year on Your Resume",
    description: "Gaps happen. Here's how to frame your time off as a period of growth rather than a red flag for recruiters.",
    slug: "describe-gap-year-on-resume",
    date: "March 5, 2026",
    image: "https://answerly.space/images/blog/topic-gap-year.png",
    category: "Career Advice"
  },
  {
    title: "FAANG Resume Keywords Guide",
    description: "How Amazon, Google, and Meta's hiring language actually differs, and a real method for finding the keywords that matter for your application.",
    slug: "faang-resume-keywords-guide",
    date: "March 2, 2026",
    image: "https://answerly.space/images/blog/topic-faang-keywords.png",
    category: "Job Search"
  },
  {
    title: "How to Check if Your Resume Is ATS-Friendly (Free Methods)",
    description: "Not getting callbacks? Here's how to check if your resume is ATS-friendly: test your formatting, keywords, and match score for free in under 5 minutes.",
    slug: "check-resume-ats-friendly-free-google-docs",
    date: "February 26, 2026",
    image: "https://answerly.space/images/blog/ats-engine-status-card.png",
    category: "ATS Strategy"
  },
  {
    title: "What Is an ATS-Friendly Resume? (Definition, Format + Examples)",
    description: "An ATS-friendly resume gets past automated filters before a human ever sees it. Here's the exact format, keyword rules, and real examples that pass ATS.",
    slug: "what-is-ats-friendly-resume",
    date: "February 26, 2026",
    image: "https://answerly.space/images/blog/homepage-ats-score-card.png",
    category: "ATS Strategy"
  },
  {
    title: "ATS-Friendly Resume Meaning: What It Actually Means",
    description: "ATS-friendly resume meaning: a resume formatted so software can read it and keywords match the job. What actually matters, and what doesn't.",
    slug: "ats-friendly-resume-meaning",
    date: "February 26, 2026",
    image: "https://answerly.space/images/blog/ats-engine-status-card.png",
    category: "ATS Strategy"
  },
  {
    title: "How to Write a Career Changer Professional Summary",
    description: "Switching careers? Write a professional summary that reframes your experience as an asset, clears ATS filters, and convinces recruiters you belong.",
    slug: "career-changer-professional-summary",
    date: "March 27, 2026",
    image: "https://answerly.space/images/blog/topic-career-changer.png",
    category: "Career Advice"
  },
  {
    title: "How to Follow Up on a Job Application (Templates + Timing)",
    description: "Following up the right way keeps you on a recruiter's radar without being annoying. Real email templates with the timing for each stage.",
    slug: "job-application-follow-up-2026",
    date: "March 28, 2026",
    image: "https://answerly.space/images/blog/topic-follow-up.png",
    category: "Job Search"
  },
  {
    title: "How to List Certifications on a Resume (ATS-Friendly Format)",
    description: "Hard-earned certs shouldn't get buried in your resume. The exact format to list certifications so ATS systems find them and recruiters notice them.",
    slug: "how-to-list-certifications-on-resume",
    date: "March 30, 2026",
    image: "https://answerly.space/images/blog/topic-certifications.png",
    category: "Resume Writing"
  },
  {
    title: "5 Signs Your Resume Passed the ATS",
    description: "Not sure if your resume made it past the bots? These signals tell you your application reached a human, plus what to do next.",
    slug: "signs-resume-passed-ats",
    date: "March 31, 2026",
    image: "https://answerly.space/images/blog/ats-engine-status-card.png",
    category: "ATS Strategy"
  },
  {
    title: "How to Access the Hidden Job Market",
    description: "Most jobs are filled before they're ever listed online. How to find and land roles in the hidden job market using networking and referrals.",
    slug: "hidden-job-market-strategy-2026",
    date: "April 1, 2026",
    image: "https://answerly.space/images/blog/topic-hidden-job-market.png",
    category: "Job Search"
  },
  {
    title: "How to Tailor Your Resume to a Job Description",
    description: "Tailoring your resume to every job description increases your callback rate. A repeatable system that takes under 10 minutes per application.",
    slug: "how-to-tailor-resume-to-job-description",
    date: "June 25, 2026",
    image: "https://answerly.space/images/blog/homepage-ats-score-card.png",
    category: "Resume Writing"
  },
  {
    title: "The Best Chrome Extension for Job Applications",
    description: "Stop switching tabs and copy-pasting answers. The best job application Chrome extensions save hours per week, here's what actually works.",
    slug: "best-chrome-extension-job-applications-2026",
    date: "June 25, 2026",
    image: "https://answerly.space/images/blog/extension-panel-in-context.png",
    category: "AI Tools"
  },
  {
    title: "How to Write a LinkedIn Summary That Gets Recruiters to Message You",
    description: "Your LinkedIn summary is the first thing recruiters read. How to write one that ranks in search, gets InMails, and sounds like a person.",
    slug: "how-to-write-linkedin-summary",
    date: "June 25, 2026",
    image: "https://answerly.space/images/blog/topic-linkedin-summary.png",
    category: "LinkedIn"
  },
  {
    title: "How to Fill Out a Workday Job Application",
    description: "Workday applications are notoriously slow and repetitive. How to get through them faster, avoid common errors, and improve your chances.",
    slug: "how-to-fill-out-workday-application",
    date: "June 25, 2026",
    image: "https://answerly.space/images/blog/topic-workday-ats.png",
    category: "ATS Strategy"
  },
  {
    title: "The Best AI Tools for Job Search",
    description: "AI job search tools range from genuinely useful to overhyped. An honest ranking of what's worth using, and what each tool is actually good for.",
    slug: "best-ai-tools-job-search-2026",
    date: "June 25, 2026",
    image: "https://answerly.space/images/blog/extension-panel-live.png",
    category: "AI Tools"
  },
  {
    title: "How to Answer 'Tell Me About Yourself' in a Job Interview",
    description: "The most common interview opener, and the most wasted opportunity. A structure that works for any role, with real examples.",
    slug: "how-to-answer-tell-me-about-yourself",
    date: "June 25, 2026",
    image: "https://answerly.space/images/blog/topic-tell-me-about-yourself.png",
    category: "Interview Prep"
  }
];

const BlogListingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-40 pb-32 bg-white min-h-screen font-['Google_Sans']">
      <SEO 
        title="Answerly Blog - Resume Tips, ATS Guides & AI Job Search"
        description="Master your job search with our expert-led blog. Learn about ATS optimization, AI resume writing, and modern career strategies."
        canonical="/blogs"
      />

      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-6 mb-20 text-center">
        <div className={`transition-all duration-1000 transform ${isLoaded ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Badge variant="blue">Career Resources</Badge>
          <h1 className="text-6xl md:text-7xl lg:text-[5.5rem] font-bold text-[#00215C] mt-6 mb-6 tracking-tight">
            The Modern Job Search Blog.
          </h1>
          <p className="text-xl text-slate-500 font-medium max-w-3xl mx-auto">
            Practical guides on ATS, AI tools, and the job hunt.
          </p>
        </div>
      </div>

      {/* Featured Post */}
      <div className="max-w-7xl mx-auto px-6 mb-20">
        <Link to={`/blogs/${BLOG_POSTS[0].slug}`} className="group block">
          <div className="bg-slate-50 rounded-[3rem] overflow-hidden border border-slate-100 flex flex-col md:flex-row items-center transition-all duration-500 hover:shadow-2xl hover:border-blue-100">
            <div className="w-full md:w-1/2 h-[300px] md:h-[500px] bg-slate-200 overflow-hidden">
              <img 
                src={BLOG_POSTS[0].image || "https://answerly.space/og-image.png"} 
                alt={BLOG_POSTS[0].title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="w-full md:w-1/2 p-12 md:p-16 space-y-6">
              <span className="text-[#0042BC] font-bold uppercase tracking-widest text-xs">{BLOG_POSTS[0].category}</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#00215C] leading-tight group-hover:text-[#0042BC] transition-colors">
                {BLOG_POSTS[0].title}
              </h2>
              <p className="text-lg text-slate-500 leading-relaxed">
                {BLOG_POSTS[0].description}
              </p>
              <div className="flex items-center gap-4 pt-4">
                <img src="https://answerly.space/images/sarath-avatar.png" alt="Sarath Chand Nekuri" className="w-10 h-10 rounded-full object-cover" />
                <div className="text-sm font-bold text-[#00215C]">
                  Sarath Chand Nekuri <br />
                  <span className="text-slate-500 font-medium">{BLOG_POSTS[0].date}</span>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* Grid Section */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {BLOG_POSTS.slice(1).map((post, i) => (
            <Link key={post.slug} to={`/blogs/${post.slug}`} className="group flex flex-col h-full">
              <div className="bg-white rounded-[2.5rem] border border-slate-100 overflow-hidden flex flex-col h-full transition-all duration-500 hover:shadow-xl hover:-translate-y-2 hover:border-blue-50">
                <div className="h-56 bg-slate-100 overflow-hidden">
                  <img 
                    src={post.image || "https://answerly.space/og-image.png"} 
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="p-8 flex flex-col flex-1">
                  <span className="text-[#0042BC] font-bold uppercase tracking-widest text-[13px] mb-4">{post.category}</span>
                  <h3 className="text-xl font-bold text-[#00215C] mb-4 leading-snug group-hover:text-[#0042BC] transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed mb-6 flex-1">
                    {post.description}
                  </p>
                  <div className="flex items-center justify-between pt-6 border-t border-slate-50">
                    <span className="text-xs font-bold text-slate-500 uppercase tracking-tighter">{post.date}</span>
                    <span className="text-[#0042BC] font-bold text-sm group-hover:translate-x-1 transition-transform inline-flex items-center gap-1">
                      Read More 
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Newsletter / CTA */}
      <div className="max-w-7xl mx-auto px-6 mt-32">
        <div className="bg-[#00215C] rounded-[3rem] p-16 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/20 blur-[80px] rounded-full"></div>
          <div className="relative z-10 space-y-8">
            <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight">The job search changes fast. Here's what's working now.</h2>
            <p className="text-blue-100 text-lg max-w-2xl mx-auto">
              Get weekly tips on ATS, AI tools, and the job hunt. No fluff, unsubscribe anytime.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 pt-4">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="px-8 py-4.5 rounded-full bg-white/10 border border-white/20 text-white placeholder:text-blue-200 focus:outline-none focus:ring-2 focus:ring-[#63BBFF] min-w-[300px] text-lg"
              />
              <ActionButton variant="primary" className="bg-[#63BBFF] text-[#00215C] hover:bg-white shadow-none px-10 py-4.5 text-lg">
                Subscribe
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogListingPage;
